/**
Project: Phone Connect (c)
Title: Index
Description: Entry point of tha application
Copyrights: This file is subject to the terms and conditions defined in file 'LICENSE.txt', which is part of this source code package.
*/
import React from "react";
import ReactDOM from "react-dom";
import "./i18n";
import App from "./app";
import "./assets/styles/index.scss";
ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);

